export const forgotPassword = {
    title: 'Forgot password',
    message: {
        sendRequestSuccess:
            'Your request has been received. We will process and respond via email',
    },
    email: {
        placeholder: 'Enter your email',
    },
    button: {
        confirm: 'Confirm',
    },
};
